import React from 'react';
import { PostCategories } from '../../../Utils/Types';

import PostsCreateMenu from './PostsCreateMenu';
import { PostTypeOrSurvey } from '../../../Utils/Types/Posts';

interface FoldersMenuProps {
  parentId?: string | number | null;
}

const types = [...PostCategories.FOLDER] as PostTypeOrSurvey[];

function FoldersMenu({ parentId }: FoldersMenuProps) {
  return <PostsCreateMenu postTypes={types} parentId={parentId} />;
}

export default FoldersMenu;
